export default __webpack_public_path__ + "static/media/1-1-5.5db84914.webp";